import { api, local } from "@/lib/api";

const KEY = "pending_checkins";
const EVT = "mm-pending-changed";

export const getPending = () => local.get(KEY, []);
const setPending = (list) => { local.set(KEY, list); window.dispatchEvent(new Event(EVT)); };

export const queueCheckin = (data) => setPending([...getPending(), { ...data, timestamp: data.timestamp || new Date().toISOString(), _qid: Date.now().toString() }]);

export const isNetworkFailure = (e) => !navigator.onLine || !e?.response || e.response.status >= 500;

let syncing = false;
export async function syncPending() {
  if (syncing || !navigator.onLine) return 0;
  syncing = true;
  let synced = 0;
  try {
    for (const item of getPending()) {
      const { _qid, ...body } = item;
      try {
        await api.post("/checkins", body);
        synced += 1;
        setPending(getPending().filter((p) => p._qid !== _qid));
      } catch (e) {
        if (isNetworkFailure(e)) break;
        setPending(getPending().filter((p) => p._qid !== _qid));
      }
    }
  } finally {
    syncing = false;
  }
  return synced;
}

export const onPendingChange = (fn) => {
  window.addEventListener(EVT, fn);
  return () => window.removeEventListener(EVT, fn);
};
